import { useState } from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineLink } from "react-icons/hi2";

import Button from "@/components/atoms/Button";
import Modal from "@/components/molecules/Modal";
import CRMModal from "@/components/organisms/crm/CRMModal";

type Props = {
  listId?: string;
  listName?: string;
};

const CRMModalHandler = ({ listId, listName }: Props) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setIsOpen(true)}
        trailingIcon={<HiOutlineLink className={"size-5"} />}
        label={t("crm.manage")}
        color={"natural"}
        size={"xs"}
        variants={"outline"}
      />

      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} content={CRMModal} contentProps={{ listId, listName }} />
    </>
  );
};

export default CRMModalHandler;
